
// ==========================================
// 12. src/App.js - MAIN APPLICATION
// ==========================================
import React, { useEffect } from 'react';
import Navigation from './components/layout/Navigation';
import Hero from './components/sections/Hero';
import ProblemSection from './components/sections/ProblemSection';
import GuideSection from './components/sections/GuideSection';
import SolutionSection from './components/sections/SolutionSection';
import HowItWorks from './components/sections/HowItWorks';
import SuccessSection from './components/sections/SuccessSection';
import CTASection from './components/sections/CTASection';
import Footer from './components/layout/Footer';
import AboutSection from './components/sections/AboutSection';
import VisionSection from './components/sections/VisionSection';
import TeamSection from './components/sections/TeamSection';
import BackToTop from './components/layout/BackToTop';
import StandardsSection from './components/sections/StandardsSection';

function App() {
  useEffect(() => {
    // Initialize Keap Forms
    const keapForms = window.keapForms || {
      SNIPPET_VERSION: '1.1.0',
      appId: 'tny480',
    };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    script.defer = true;
    script.src = 'https://forms.keap.app/lib/public-form-embed.js?appId=tny480&version=1.1.0';

    script.onload = function () {
      const keapFormsAfterLoad = window.keapForms;
      if (!keapFormsAfterLoad?.renderAllForms) {
        console.error('[Keap Forms] Error: could not load');
      } else if (!keapFormsAfterLoad.invoked) {
        keapFormsAfterLoad.invoked = true;
        keapFormsAfterLoad.renderAllForms();
      }
    };

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    window.keapForms = keapForms;
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <ProblemSection />
      <GuideSection />
      <SolutionSection />
      <StandardsSection />
      <HowItWorks />
      <SuccessSection />
      <CTASection />
      <AboutSection />
      <TeamSection />
      <VisionSection />
      <Footer />
      <BackToTop/>
    </div>
  );
}

export default App;